export default __webpack_public_path__ + "static/media/pic4.290e8f94.PNG";